export default "__VITE_ASSET__DDNr6yaY__"